import { Stack, useTheme } from '@mui/material';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { getAnalytics } from '../../../../api';
import { Flex } from '../../../../common';
import { LineCharts } from '../../../../components/Charts/LineChart';
import { FilterYearMonthCategoryProduct } from '../../../../components/FilterModals/FilterYearMonthCategoryProduct';

const initialFilter = {
  year: null,
  month: null,
  category: {
    name: null,
    id: null,
  },
  product: {
    name: null,
    id: null,
  },
};

export const TotalProductsOrdersChart = () => {
  const theme = useTheme();
  const [filterOpen, setFilterOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState(initialFilter);
  const [value, setValue] = useState([]);
  const [totalValue, setTotalValue] = useState(0);

  const onSave = (value: any) => {
    setFilter((prev) => ({
      ...prev,
      ...value,
    }));
    setFilterOpen(false);
  };
  const getData = async () => {
    setLoading(true);
    const data = await getAnalytics('products/total-orders', {
      year: filter.year,
      month: filter.month,
      categoryId: filter.category?.id,
      productId: filter.product?.id,
    });
    console.log(data?.data.data);
    setValue(data?.data.data);
    setLoading(false);
  };
  useEffect(() => {
    getData();
  }, [filter]);

  const sum: any = value.reduce((accumulator, object: any) => {
    return accumulator + object.total;
  }, 0);

  const clearFilter = () => setFilter(initialFilter);
  return (
    <Flex column fullHeight>
      <LineCharts
        data={value}
        title={`Total Products Orders: ${sum ? sum / 100 : 0}£`}
        openFilter={() => setFilterOpen(true)}
        filter={{
          year: filter.year,
          month: filter.month,
          category: filter.category?.name,
          product: filter.product?.name,
        }}
        initialFilter={initialFilter}
        realFilter={filter}
        clearFilter={clearFilter}
        loading={loading}
        color={theme.color.graphRed}
      />

      <FilterYearMonthCategoryProduct
        open={filterOpen}
        handleClose={() => setFilterOpen(false)}
        onSave={onSave}
      />
    </Flex>
  );
};
